export default "/images/ea0866fb548864a683ca0be69996cff7.avif";